export default __webpack_public_path__ + "static/media/gas.5a94133a.svg";